import cloneDeep from 'lodash.clonedeep';
import { mapGetters, mapMutations } from 'vuex';
import { VUEX_GENERAL, VUEX_BENEFIT_QUOTES_CLAIMS } from '@/constants/VuexConstants';
import { getAccessLevel, isBuildCRM } from '@/utils';

import CRMSupportMixins from '../CRMSupportMixins';

const isCRM = isBuildCRM();

export default {
  mixins: [CRMSupportMixins],

  data() {
    return {
      isCRM,
      apiStatus: {
        loading: true, // default
        fail: false, // default
      },
      pages: {
        NEW_BENEFIT_QUOTE: {
          pageNumber: 1,
          stepName: 'NewBenefitQuote',
          isInvalid: true,
          props: {},
        },
        PROVIDER_SEARCH: {
          pageNumber: 2,
          stepName: 'ProviderSearch',
          isInvalid: true,
          props: {},
        },
        PROVIDER_SEARCH_RESULTS: {
          pageNumber: 3,
          stepName: 'SelectProvider',
          isInvalid: true,
          props: {},
        },
        SERVICE_INFORMATION: {
          pageNumber: 4,
          stepName: 'EnterServiceInformation',
          isInvalid: true,
          props: {},
        },
        REVIEW: {
          pageNumber: this.isClaim ? 6 : 5,
          stepName: 'ReviewAndSubmit',
          props: {},
        },
        PAYMENT_INFORMATION: {
          pageNumber: this.isClaim ? 5 : null,
          stepName: 'PaymentInformation',
          isInvalid: true,
          props: {},
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      policyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      currentMemberDetail: VUEX_GENERAL.GETTERS.getCurrentMemberDetails,
      memberships: VUEX_GENERAL.GETTERS.memberships,
      members: VUEX_GENERAL.GETTERS.getMembers,
    }),

    ...mapGetters('BenefitQuotesClaims', {
      refData: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getRefData,
      feature: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getFormResponse,
      currentPage: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getCurrentPage,
      stepsInvalidStatus: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getFormResponseStepsInvalid,
      fileUploadStatus: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getFileUploadStatus,
      fileRemovedStatus: VUEX_BENEFIT_QUOTES_CLAIMS.GETTERS.getFileRemovedStatus,
    }),
  },

  methods: {
    ...mapMutations('BenefitQuotesClaims', {
      clearAllDataFromApis: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.resetState,
      resetRefGeneral: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.resetRefGeneral,
      updatePageNumber: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateCurrentPage,
      updateRefGeneral: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateRefGeneral,
      updateFormResponse: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateFormResponse,
      updateStepInvalidStatus: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateFormResponseStepsInvalid,
      updateFileUpload: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateFileUpload,
      updateFileRemoved: VUEX_BENEFIT_QUOTES_CLAIMS.MUTATIONS.updateFileRemoved,
    }),

    updatePage(pageNum) {
      this.updatePageNumber(pageNum);
      this.$route.query.step = `${pageNum}`;
    },

    handleNextPage(pageNum) {
      this.updatePage(pageNum);
      this.$emit('scrollToTopForm');
    },

    accessLevel(policyNumber) {
      return getAccessLevel(policyNumber, this.memberships);
    },

    cloneDeep,
  },
};
